namespace AgerLMS.WebSite {

    export interface LearningPageWidgetRequest {
        rightClickDisabled : boolean;
    }

    @Serenity.Decorators.registerClass()
    export class LearningPageWidget extends Serenity.Widget<LearningPageWidgetRequest> {

        contentElement: JQuery;

        constructor(element: JQuery, opt: LearningPageWidgetRequest) {
            super(element, opt);

            this.contentElement = $("#learningPageContent");

            if (opt.rightClickDisabled) {
                document.addEventListener(
                    "contextmenu",
                    function (t) {
                        return t.preventDefault();
                    },
                    !1
                );
            }

            var self = this;
            $("body").on("click", ".tab-item", function () {
                let e = $(this);
                if (!e.hasClass("active")) {
                    var n = e.attr("data-type"),
                        o = e.attr("data-id");
                    $(".tab-item-info").slideUp(),
                    $(".tab-item").removeClass("active"),
                    $(".certificate-item").removeClass("active"),
                    e.addClass("active"),
                    e.find(".tab-item-info").slideDown(),
                    $(window).width() < 992 && $(".learning-page-tabs").removeClass("show"),
                    "assignment" !== n && (self.loading(), self.a(o, n));
                }
            });
        }

        private a(n : any, a: any) {
            var self = this;
            var i = { type: a, id: n };
            $.post(Q.resolveUrl("~/course/learning/itemInfo"), i, function (n) {
                if ("session" === a) {
                    // var i = n.session;
                    // i &&
                    //     (i.is_finished
                    //         ? ((s = sessionIsFinishedLang),
                    //           (r = sessionIsFinishedHintLang),
                    //           (l = '\n                <a href="'.concat(courseUrl, '" class="btn btn-white btn-sm mt-15">').concat(coursePageLang, "</a>\n        ")),
                    //           (c = self.o(s, r, "live_session.svg", l, "mt-10")),
                    //           self.contentElement.html(c))
                    //         : i.is_started
                    //         ? (function (t) {
                    //               var n = sessionIsLiveLang,
                    //                   a = youCanJoinTheLiveNowLang,
                    //                   i = '\n            <div class="d-flex align-items-center mt-15">\n                <a href="'
                    //                       .concat(t.join_url, '" target="_blank" class="btn btn-primary btn-sm ">')
                    //                       .concat(joinTheClassLang, '</a>\n                <a href="')
                    //                       .concat(courseUrl, '" class="btn btn-white btn-sm ml-10">')
                    //                       .concat(coursePageLang, "</a>\n            </div>\n        "),
                    //                   s = self.o(n, a, "live_session.svg", i, "mt-10");
                    //               self.contentElement.html(s);
                    //           })(i)
                    //         : (function (t) {
                    //               var n = sessionIsNotStartedYetLang,
                    //                   a = thisSessionWillBeStartedOnLang + " " + t.start_data,
                    //                   i = '\n            <div class="d-flex align-items-center mt-15">\n                <button type="button" id="checkAgainSession" data-type="session" data-id="'
                    //                       .concat(t.id, '" class="btn btn-primary btn-sm ">')
                    //                       .concat(checkAgainLang, '</button>\n                <a href="')
                    //                       .concat(courseUrl, '" class="btn btn-white btn-sm ml-10">')
                    //                       .concat(coursePageLang, "</a>\n            </div>\n        "),
                    //                   s = self.o(n, a, "live_session.svg", i, "mt-10");
                    //               self.contentElement.html(s);
                    //           })(i));
                } else
                    "file" === a
                        ? (function (n) {
                              if ((n.online_viewer && "0" !== n.online_viewer) || (n.downloadable && "0" !== n.downloadable)) {
                                  var a = "";
                                  if (n.online_viewer && "0" !== n.online_viewer)
                                      (a += '<div class="d-flex flex-column p-10 h-100">'),
                                          (a += '<iframe src="/ViewerJS/index.html#'
                                              .concat(n.file_path, '" class="file-online-viewer rounded-sm ')
                                              .concat(n.downloadable && "0" !== n.downloadable ? "has-download-card" : "", '" frameborder="0" allowfullscreen></iframe>'));
                                              //,
                                        //   n.downloadable &&
                                        //       "0" !== n.downloadable &&
                                        //       (a += '<div class="d-flex align-items-center justify-content-between rounded-sm mt-15 p-15 border-dashed-gray300">\n                                <span class="font-weight-bold text-dark">'
                                        //           .concat(downloadTheFileLang, '</span>\n                                <a href="')
                                        //           .concat(courseUrl, "/file/")
                                        //           .concat(n.id, '/download" class="btn btn-primary btn-sm" target="_blank">')
                                        //           .concat(downloadLang, "</a>\n                            </div>")),
                                        //   (a += "</div>");
                                  else if (n.downloadable && "0" !== n.downloadable) {
                                    //   var i = downloadTheFileLang,
                                    //       s = n.title,
                                    //       r = '<a href="'.concat(courseUrl, "/file/").concat(n.id, '/download" class="btn btn-primary btn-sm mt-15" target="_blank">').concat(downloadLang, "</a>");
                                    //   a += self.o(i, s, "download.svg", r);
                                  }
                                  self.contentElement.html(a);
                              } else
                                  switch (n.storage) {
                                      case "upload":
                                      case "youtube":
                                      case "vimeo":
                                      case "external_link":
                                      case "s3":
                                        if (n.can_try) {
                                          var w = $('<div class="learning-content-video-player w-100"></div>');
                                          self.contentElement.html(w as any); 
                                          (window as any).handleVideoByFileId(n.id, w, function () {});
                                        }
                                        else 
                                        {
                                            let s = self.o("İzleme hakkınız dolmuştur.", "", "quiz.svg", "");
                                            self.contentElement.html(s);
                                        }
                                        break;
                                      case "google_drive":
                                      case "iframe":
                                        //   (g = n.id),
                                            //   $.post("/course/getFilePath", { file_id: g }, function (n) {
                                            //           if (n && 200 === n.code) {
                                            //               n.storage;
                                            //               var a = n.path,
                                            //                   o = '<div class="learning-content-iframe">\n                            '.concat(a, "\n                        </div>");
                                            //               self.contentElement.html(o);
                                            //           } else $.toast({ heading: notAccessToastTitleLang, text: notAccessToastMsgLang, bgColor: "#f63c3c", textColor: "white", hideAfter: 1e4, position: "bottom-right", icon: "error" });
                                            //       })
                                            //       .fail(function (e) {
                                            //           $.toast({ heading: notAccessToastTitleLang, text: notAccessToastMsgLang, bgColor: "#f63c3c", textColor: "white", hideAfter: 1e4, position: "bottom-right", icon: "error" });
                                            //       });
                                          break;
                                      case "upload_archive":
                                        //   var c = showHtmlFileLang,
                                        //       d = n.title,
                                        //       f = '<a href="'.concat(courseUrl, "/file/").concat(n.id, '/showHtml" target="_blank" class="btn btn-primary btn-sm mt-15">').concat(showLang, "</a>"),
                                        //       u = self.o(c, d, "download.svg", f);
                                        //   self.contentElement.html(u);
                                  }
                              var g;
                          })(n.file)
                        : "quiz" === a &&
                          (function (t) {
                              var title = n.title,
                                  a = "goToTheQuizPageForMoreInformationLang",
                                  i = "";
                              i = n.can_try
                                  ? '\n<a href="/lms/'.concat(n.id, '/quiz-start" target="_blank" class="btn btn-primary btn-sm mt-15">').concat("quizPageLang", "</a>\n            ")
                                  : '\n<button type="button" class="js-cant-start-quiz-toast btn btn-primary btn-sm mt-15 disabled">'.concat("quizPageLang", "</button>\n            ");
                              var s = self.o(title, a, "quiz.svg", i);
                              self.contentElement.html(s);
                          })(n.quiz);
                var s, r, l, c;
            });
        }

        // private i() {
        //     SweetAlert.swal_alert("test", "test")
        // }

        private o(t, e, n, y = null) {
            var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
                o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
            return '<div class="d-flex align-items-center justify-content-center w-100 h-100">\n                    <div class="learning-content-box d-flex align-items-center justify-content-center flex-column p-15 p-lg-30 rounded-lg">\n                        <div class="learning-content-box-icon">\n                            <img src="/lms/assets/default/img/learning/'
                .concat(n, '" alt="downloadable icon">\n                        </div>\n\n                        <h4 class="font-16 font-weight-bold text-dark ')
                .concat(null != o ? o : "", '">')
                .concat(t, '</h4>\n\n                        <span class="font-14 font-weight-500 text-gray mt-5">')
                .concat(e, "</span>\n\n                        ")
                .concat(null != a ? a : "", "\n                    </div>\n                </div>");
        }
        private loading() {
            var t = '<div class="learning-content-loading d-flex align-items-center justify-content-center flex-column w-100 h-100">\n            <img src="/lms/assets/default/img/loading.gif" alt="">\n            <p class="mt-10">'.concat(
                Q.text("WebSite.Text.pleaseWaitForTheContentLang"),
                "</p>\n        </div>"
            );
            this.contentElement.html(t);
        }

        private yourrighttowatchhasexpired() {
            var t = '<div class="learning-content-loading d-flex align-items-center justify-content-center flex-column w-100 h-100">\n            <img src="/lms/assets/default/img/loading.gif" alt="">\n            <p class="mt-10">'.concat(
                "İzleme hakkınızın süresi dolmuştur.",
                "</p>\n        </div>"
            );
            this.contentElement.html(t);
        }
    }
}